import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import {
  Alert,
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { LINKS, NOTIFICATION_POSITIONS, NOTIFICATION_GROUPS } from "@constants";
import { notificationDelete } from "actions/notification";
import { arrayDiff } from "utils";
import { PAGE_VIEW_FROM } from "services/events";

const conversionResultDataKeys = ["projectUrl", "folderId"];

const Notifier = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const {
    [NOTIFICATION_GROUPS.general]: { ids: notificationIds, hash },
  } = useSelector((state) => state.notification);
  const { isAuthenticated, demoWizard } = useSelector((state) => state.auth);

  const ids = [...(notificationIds || [])].reverse().slice(0, 4);

  const handleUpgradePlanClick = () => {
    navigate(LINKS.plan, { state: { from: PAGE_VIEW_FROM.upgrade_plan } });
  };

  const proceedNotifications = (notifications) => {
    return notifications.map((id) => {
      const item = hash[id];
      return (
        <Box key={id}>
          <Alert
            onClose={() => dispatch(notificationDelete({ id }))}
            severity={item.type}
            sx={{
              minWidth: "auto",
              width: isDesktop ? "600px" : "calc(100% - 48px)",
              maxWidth: "600px",
              marginLeft: {
                sm:
                  (item.position && item.position.includes("center")) ||
                  isDesktop
                    ? isDesktop
                      ? "0"
                      : "calc(50vw - 50%)"
                    : "288px",
                xs: "24px",
              },
            }}
            data-testid="notification"
          >
            {typeof item.messages === "string" &&
              item.messages.indexOf("Upgrade Plan") > 0 &&
              isAuthenticated &&
              demoWizard?.ignoreWizard && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="subtitle1">{item.messages} </Typography>
                  <Button
                    onClick={handleUpgradePlanClick}
                    variant="contained"
                    size="small"
                    sx={{ ml: "10px" }}
                  >
                    Upgrade Plan
                  </Button>
                </Box>
              )}
            {typeof item.messages === "string" &&
              (item.messages.indexOf("Upgrade Plan") === -1 ||
                (item.messages.indexOf("Upgrade Plan") > 0 &&
                  isAuthenticated &&
                  !demoWizard?.ignoreWizard)) && <>{item.messages}</>}
            {typeof item.messages === "object" &&
              arrayDiff(conversionResultDataKeys, Object.keys(item.messages))
                .length === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="subtitle1">
                    Conversion complete.{" "}
                  </Typography>
                  <Button
                    component={Link}
                    to={item.messages.projectUrl}
                    state={{
                      folderId: item.messages.folderId,
                      originalId: item.messages.originalId,
                    }}
                    variant="contained"
                    size="small"
                    sx={{ ml: "10px" }}
                  >
                    Check it now
                  </Button>
                </Box>
              )}
            {typeof item.messages === "object" &&
              item.messages?.error_code &&
              item.messages.detail}
            {typeof item.messages === "object" &&
              !item.messages.error_code &&
              item.messages.message}
          </Alert>
        </Box>
      );
    });
  };

  return (
    <Box sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}>
      <Stack
        sx={{
          position: "absolute",
          bottom: { sm: "32px", xs: "24px" },
          left: isDesktop ? "50%" : 0,
          right: 0,
          width: { sm: "min-content", xs: "100%" },
          transform: isDesktop ? "translateX(-50%)" : "none",
        }}
        spacing={2}
      >
        {proceedNotifications(
          ids.filter((id) =>
            hash[id].position.includes(NOTIFICATION_POSITIONS.bottom)
          )
        )}
      </Stack>
      <Stack
        sx={{
          position: "absolute",
          top: { sm: "32px", xs: "24px" },
          left: 0,
          right: 0,
          width: { sm: "min-content", xs: "100%" },
        }}
        spacing={2}
      >
        {proceedNotifications(
          ids.filter((id) =>
            hash[id].position.includes(NOTIFICATION_POSITIONS.top)
          )
        )}
      </Stack>
    </Box>
  );
};

export default Notifier;
